import { ButtonLink, PlusIcon, Stack, TablePager } from '@fukuri-admins/ui/common';
import { ROUTES } from '~/utils/routes';
import { InternalNewsTable } from './InternalNewsTable';
import styles from './styles.module.scss';

type Props = {
  items: React.ComponentProps<typeof InternalNewsTable>['items'];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onDetailClick: (id: number) => void;
  /** ページネーション */
  pagerProps: React.ComponentProps<typeof TablePager>;
};

/**
 * 社内報一覧 Presentation コンポーネント
 *
 * リスト表示専用。Empty 表示の出し分けは Container 層で行う。
 */
export const InternalNewsListPresentation: React.FC<Props> = ({
  items,
  onEdit,
  onDelete,
  onDetailClick,
  pagerProps,
}) => (
  <Stack gap={16}>
    <div className={styles.titleWrapper}>
      <ButtonLink to={ROUTES.INTERNAL_NEWS.NEW} icon={<PlusIcon size='xs' />} iconPosition='left'>
        新規作成
      </ButtonLink>
    </div>
    <InternalNewsTable
      items={items}
      onEdit={onEdit}
      onDelete={onDelete}
      onDetailClick={onDetailClick}
    />
    <TablePager {...pagerProps} />
  </Stack>
);
